(() => {
  // Gallery: swipe/scroll track + thumbs + arrows
  function initGallery(root) {
    const track = root.querySelector('.skk-gallery__track');
    if (!track || track.dataset.ready) return;
    track.dataset.ready = '1';
    const slides = [...track.querySelectorAll('.skk-gallery__img')];
    const thumbs = [...root.querySelectorAll('.skk-gallery__thumb')];
    let current = 0;
    const mark = (i) => {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      thumbs.forEach((t, n) => t.classList.toggle('is-active', n === current));
    };
    const go = (i) => { mark(i); track.scrollTo({ left: track.clientWidth * current, behavior: 'smooth' }); };
    thumbs.forEach((t) => t.addEventListener('click', () => go(Number(t.dataset.target))));
    root.querySelector('.skk-gallery__prev')?.addEventListener('click', () => go(current - 1));
    root.querySelector('.skk-gallery__next')?.addEventListener('click', () => go(current + 1));
    let timer;
    track.addEventListener('scroll', () => {
      clearTimeout(timer);
      timer = setTimeout(() => mark(Math.round(track.scrollLeft / track.clientWidth)), 80);
    }, { passive: true });
  }

  // Moon Bundles: mirror the selected bundle option into the quantity input
  function syncBundle(root, form) {
    const options = [...root.querySelectorAll('#moonbundle-option')];
    const active = root.querySelector('#moonbundle-option.moonbundle-option-active');
    const index = options.indexOf(active);
    const qty = form.querySelector('input[name="quantity"]');
    if (index >= 0 && qty) qty.value = String(index + 1);
  }

  // Add to cart -> open Dawn cart drawer. Falls back to normal submit (/cart) if no drawer.
  function initForm(form) {
    if (form.dataset.ready) return;
    form.dataset.ready = '1';
    const root = form.closest('[data-skk-section]') || document;
    form.addEventListener('submit', (event) => {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.renderContents !== 'function') return;
      event.preventDefault();
      if (form.dataset.busy === '1') return;
      syncBundle(root, form);
      form.dataset.busy = '1';
      const button = form.querySelector('[type="submit"]');
      const label = button.innerHTML;
      button.disabled = true;
      button.textContent = form.dataset.loadingText || 'Lägger till…';
      const data = new FormData(form);
      data.append('sections', drawer.getSectionsToRender().map((s) => s.id).join(','));
      data.append('sections_url', window.location.pathname);
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: data
      })
        .then((r) => r.json())
        .then((state) => {
          if (state.status) throw new Error(state.description || state.message);
          drawer.classList.remove('is-empty');
          drawer.setActiveElement && drawer.setActiveElement(button);
          drawer.renderContents(state);
          button.innerHTML = label;
        })
        .catch((err) => {
          console.error(err);
          button.textContent = form.dataset.errorText || 'Något gick fel – försök igen';
          setTimeout(() => { button.innerHTML = label; }, 2500);
        })
        .finally(() => { form.dataset.busy = '0'; button.disabled = false; });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-skk-gallery]').forEach(initGallery);
    (scope || document).querySelectorAll('form.skk-form').forEach(initForm);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
